import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setTimeLeft as setTL } from './timer.slice';

export default function useCountdownTimer() {
  const { timeLeft } = useSelector((state) => state.timer);
  const dispatch = useDispatch();

  const setTimeLeft = (timeLeft) => {
    dispatch(setTL(Math.trunc(timeLeft / 1000)));
  };

  return {
    timeLeft,
    setTimeLeft,
  };
}
